import React, { useEffect, useState } from "react";
import { useSettings } from "@/lib/SettingsContext";

const KEY = "iav_cookies_v1";

const CookieBanner: React.FC = () => {
  const { settings } = useSettings();
  const [dismissed, setDismissed] = useState(true);

  useEffect(() => {
    if (typeof window === "undefined") return;
    setDismissed(!!window.localStorage.getItem(KEY));
  }, []);

  const visible = settings.cookie_banner_enabled === "true" && !dismissed;

  // Publish the banner's visibility on <body> so pages can reserve bottom space
  // via CSS (responsive.css → body.iav-cookie-open { padding-bottom: … }).
  useEffect(() => {
    document.body.classList.toggle("iav-cookie-open", visible);
    return () => document.body.classList.remove("iav-cookie-open");
  }, [visible]);

  if (!visible) return null;

  const accept = () => { try { localStorage.setItem(KEY, "1"); } catch {} setDismissed(true); };

  return (
    <div className="iav-cookie" data-testid="cookie-banner">
      <div className="iav-cookie-text">{settings.cookie_banner_text || "We use cookies to enhance your experience."}</div>
      <button className="iav-btn iav-btn-primary" onClick={accept} data-cursor="cta" data-testid="cookie-accept">Accept</button>
    </div>
  );
};
export default CookieBanner;
